import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const merge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ["page-x", "page-y", "section", "surface"],
      gap: ["section"],
    },
    classGroups: {
      "max-w": [{ "max-w": ["reading", "page", "wide"] }],
      "font-size": [
        {
          text: [
            "page-title",
            "section-title",
            "feature-title",
            "metric",
            "body",
            "supporting",
            "instrument",
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return merge(clsx(inputs));
}
